import React from "react";
import foto from "../../assets/12_Quienes somos/Sobre nosotros/sobre-nosotros-progreso-para-la-humanidad-dedicacion-movilidad.webp";

/*eslint-disable */

declare const window: any;
const ProgresoComponent: React.FC = () => {
  return (
    <div className="progreso-para-la-humanidad">
      <div className="left">
        <img 
          src={foto} 
          alt="Progreso para la Humanidad - Dedicación y movilidad" 
        />
      </div>
      <div className="right">
        <div className="title">Progreso para la Humanidad</div>
        <div className="description">
          Nuestra dedicación por el progreso de la humanidad se refleja en todo lo que hacemos, inspirándonos a concebir, crear y diseñar vehículos que abran nuevos capítulos en la movilidad y ayuden a redefinir nuestro viaje como comunidad global.
        </div>
      </div>
    </div>
  );
};

export default ProgresoComponent;
